import { capitalize } from '@homamo/meadow-utils';
import getFreedomDate from './getFreedomDate';

/**
 * Calculates the age a user will be when their mortgage has ended
 *
 * @param {string} userDobMonth
 * @param {string} userDobYear
 * MUST PROVIDE ONE OF THE FOLLOWING
 * @param {number} [remainingTerm] In months
 * @param {date} [freedomDate] As a date
 * OPTIONAL: From date (used in testing)
 * @param {number} [fromDate]
 *
 * @return {number} Age in years
 *
 */

const dayjs = require('dayjs');
const customParseFormat = require('dayjs/plugin/customParseFormat');

dayjs.extend(customParseFormat);

const getFreedomAge = (args) => {
  // Check arguments
  if (!args.userDobYear || !args.userDobMonth) return null;
  // Remaining term can be zero!
  if (!args.remainingTerm && args.remainingTerm !== 0 && !args.freedomDate)
    throw new Error(
      'Must provide either remainingTerm in months or freedomDate',
    );

  const freedomDate =
    args.freedomDate ||
    getFreedomDate({
      remainingTerm: args.remainingTerm,
      fromDate: args.fromDate || undefined,
    });

  // Safari needs the custom format to parse the date
  const dob = dayjs(
    `${capitalize(args.userDobMonth)} ${args.userDobYear}`,
    'MMM YYYY',
  );

  const freedomAge = dayjs(freedomDate).diff(dob, 'month') / 12;
  const isBirthdayMonth =
    dayjs(freedomDate).format('MMM') === capitalize(args.userDobMonth);

  return Math.floor(isBirthdayMonth ? freedomAge : freedomAge + 1);
};

export default getFreedomAge;
